import styles from "./ImageSection.module.css"
import carImage from "../../images/carImg.webp"

export default function ImageSection() {
  return(
    <div className={styles.container}>
      <h3 className={styles.label_jade}>Работаем 24/7</h3>
      <h3 className={styles.label_orange}>Осмотр за 1 час</h3>
      <img className={styles.carImage} src={carImage} alt="Машина" />
      <h3 className={styles.label_green}>Любые авто</h3>
      <h3 className={styles.label_blue}>Гарантия сделки</h3>
    </div>
  )
}